export const loaderConstants = {
  SHOW_LOADER: "LOADER_SHOW_LOADER",
  HIDE_LOADER: "LOADER_HIDE_LOADER"
};
